import React, { Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { wtGetFromLocalStorage } from './helpers/commons/LocalStorage'
import './scss/style.scss'
import { connect } from 'react-redux'
import PropertyProfile from './views/PropertyProfile'
import ViewProperty from './views/PropertyProfile/viewProperty'
function App(props) {
  
  // Investors may only open these pages; everything else sends them to Market report
  const INVESTOR_PATHS = ['/market-report', '/my-profile']

  const AuthenticatedRoutes = ({ children }) => {
    const authUser = wtGetFromLocalStorage('authUser')
    const location = useLocation()
    if (!authUser) return <Navigate to="/" />
    if (authUser.role_name === 'Investor' && !INVESTOR_PATHS.includes(location.pathname)) {
      return <Navigate to="/market-report" replace />
    }
    return children
  }

  const CheckLogin = () => {
    const authUser = wtGetFromLocalStorage('authUser')
    return authUser ? <Navigate to="/dashboard" /> : <Login />
  }

  const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
  // Pages
  const Login = React.lazy(() => import('./views/pages/login/Login'))
  const Register = React.lazy(() => import('./views/pages/authpages/SignUp'))
  const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
  const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
  const ForgotPassword = React.lazy(() => import('./views/pages/authpages/ForgotPassword'))
  const ResetPassword = React.lazy(() => import('./views/pages/authpages/ResetPassword'))
  const FindAgent = React.lazy(() => import('./views/pages/authpages/FindAgent'))
  const SetPassword = React.lazy(() => import('./views/pages/authpages/SetPassword'))
  const Privacy = React.lazy(() => import('./views/pages/authpages/Privacy'))
  return (
    <Suspense>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" name="Login Page" element={<CheckLogin />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/forgot-password" name="Forgot Password" element={<ForgotPassword />} />
          <Route exact path="/reset-password/:token" name="Reset Password" element={<ResetPassword />} />
          <Route exact path="/find-agent" name="Find Agent" element={<FindAgent />} />
          <Route exact path="/set-password/:token" name="Set Password" element={<SetPassword />} />
          <Route exact path="/privacy" name="Privacy Policy" element={<Privacy />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/property-profile/:id/:token" name="Page 500" element={<ViewProperty />} />

          <Route
            path="*"
            element={
              <AuthenticatedRoutes>
                <DefaultLayout authToken={props.authToken} authUser={props.authUser} idle_timeout={props.idle_timeout} />
              </AuthenticatedRoutes>
            }
          />
        </Routes>
      </BrowserRouter>
    </Suspense>
  )
}

const mapStateToProps = (state) => {
  return {
    authToken: state.authToken,
    authUser: state.authUser,
    idle_timeout: state.idle_timeout,
  }
}

export default connect(mapStateToProps)(App)